module.exports = __webpack_public_path__ + "img/model_40_ug.fbad89ab.jpg";